import React, { useEffect } from 'react';
import type { RouteComponentProps } from 'react-router-dom';

import useTitle from 'hooks/useTitle';
import { useFetchDesignationByIdQuery } from 'hooks/query/useDesignationQueries';
import DesignationForm from './components/DesignationForm';
import Loading from 'components/common/loading/Loading';
import BackButton from 'components/common/button/BackButton';

import { DESIGNATION } from 'constants/routes';

import history from 'utils/history';

import type { Designation } from 'interface/designation';

type MatchParams = {
  id?: string;
};

type Props = RouteComponentProps<MatchParams>;

type FetchByIdResponse = {
  data: Designation;
};

function AddEditDesignation(props: Props) {
  const designationId = props.match.params?.id;

  const title = designationId ? 'Edit Designation' : 'Add Designation';
  const setTitle = useTitle();

  useEffect(() => {
    setTitle(title);
  }, [title, setTitle]);

  const {
    data: fetchedResponse,
    isLoading,
    isError,
  } = useFetchDesignationByIdQuery<FetchByIdResponse>(designationId, Boolean(designationId));

  const designation = fetchedResponse?.data;

  useEffect(() => {
    if (!designation?.name || !designationId) {
      return;
    }

    setTitle(`Edit Designation - ${designation.name}`);
  }, [designation?.name, designationId, setTitle]);

  useEffect(() => {
    if (isError && designationId) {
      history.push(DESIGNATION);
    }
  }, [isError, designationId]);

  return (
    <div className="full-scope-card">
      <div className="full-scope-card__header table-header name-wrap">
        <div className="d-flex flex-row">
          <BackButton />
          <div className="d-flex flex-row">
            <div className="table-header">
              <h3 className="text-bold">{title}</h3>
            </div>
          </div>
        </div>
      </div>

      {isLoading && designationId ? (
        <div className="loading-min-height">
          <Loading />
        </div>
      ) : (
        <DesignationForm designation={designation} />
      )}
    </div>
  );
}

export default AddEditDesignation;
